import { render } from "./TitleArea.vue?vue&type=template&id=fd9780e2&scoped=true"
import script from "./TitleArea.vue?vue&type=script&lang=js"
export * from "./TitleArea.vue?vue&type=script&lang=js"

import "./TitleArea.vue?vue&type=style&index=0&id=fd9780e2&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd9780e2"]])

export default __exports__